import theme from '@styles/theme';
import { TInspirationProductImageJustify } from '@features/cms/typescript';
export default {
  inspirationDuoSection: (bg: string, mobilePadding: string[]) => ({
    bg,
    display: 'flex',
    p: [`${mobilePadding[0]} 0 ${mobilePadding[1]}`, `${mobilePadding[0]} 0 ${mobilePadding[1]}`, `${mobilePadding[0]} 0 ${mobilePadding[1]}`, '0 2.083333333vw'],
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: ['wrap', 'wrap', 'wrap', 'nowrap'],
    rowGap: '40px',
    columnGap: '1.25vw',
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  }),
  duoSectionImageBox: (justify?: TInspirationProductImageJustify) => ({
    width: ['auto', 'auto', 'auto', '47.2916667vw'],
    display: 'flex',
    justifyContent: justify || 'center'
  })
};